'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "onClose"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import PersonalizeBrowser from './PersonalizeBrowser';
import { KeyTypes, PopoverType } from '../../constants/popover';
import { i18nKey } from '../../utils/properties';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PersonalizePopoverBody(props) {
  const {
      type,
      onClose
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleKeyDown = event => {
    if (event.key === KeyTypes.ESCAPE) {
      onClose();
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "325px",
    paddingBlockStart: "500",
    tabIndex: "-1",
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/_jsx(H4, {
      paddingInline: "500",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`title.${type}`)
      })
    }), /*#__PURE__*/_jsx(PersonalizeBrowser, Object.assign({
      isInsert: type === PopoverType.INSERT,
      onClose: onClose
    }, rest))]
  });
}